import { createContext } from 'react';

const Context = createContext();
const CreateAudienceDataContext = createContext();
const CreateOperationDataContext = createContext()

export { Context, CreateAudienceDataContext, CreateOperationDataContext };
